<template>
  <div class="exhibitorHome">
    <div class="service">
      <div class="header">
        <div class="service_h">资讯中心</div>
        <div class="more" @click="moreClick('/exhibitorHome/service')">更多&nbsp;>></div>
      </div>
      <div style="height: 300px;overflow: hidden;">
        <ul class="service_ul">
          <li v-for="(o,i) in sList" :key="i" @click="serviceInfo(o.id)">
            <div class="leftDiv">{{ o.title }}</div>
            <div class="rightDiv">{{ o.createDate }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="product">
      <div class="header">
        <div class="service_h">产品中心</div>
        <div class="more" @click="moreClick('/exhibitorHome/product')">更多&nbsp;>></div>
      </div>
      <div class="pContent">
        <div class="c1">
          <div v-for="(o,i) in pList" :key="i" @click="productInfo(o.id)">
            <img :src="$getSrc(o.image)" crossorigin alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["exhibitorId"],
  data() {
    return {
      pList: [],
      sList: [],
      fromRoute: "",
    };
  },
  watch: {
    exhibitorId(val) {
      this.getServiceProduct(val);
    },
  },
  mounted() {
    let sessionAccountId = sessionStorage.getItem("accountId");
    if (sessionAccountId) {
      this.getServiceProduct(sessionAccountId);
    } else {
      this.getServiceProduct(this.exhibitorId);
    }
  },
  methods: {
    getServiceProduct(id) {
      this.$http({
        url: "getAccountIndex",
        method: "post",
        params: {
          accountId: id,
        },
      }).then(({ data }) => {
        let { code, information, product, msg } = data;
        if (code === 0) {
          information.forEach((element) => {
            element.createDate = element.createDate.substring(0, 10);
          });
          this.pList = product;
          this.sList = information;
        } else {
          console.log(msg);
        }
      });
    },

    moreClick(name) {
      this.$router.push({
        path: name,
      });
      this.$store.commit("SET_HOME_SERVICE_ID", this.exhibitorId);
    },

    // 资讯详情
    serviceInfo(id) {
      this.$store.commit("SET_HOME_SERVICE_ID", id);
      this.$router.push({
        path: "/exhibitorHome/service",
        query: {
          status: 0,
        },
      });
    },
    // 产品详情
    productInfo(id) {
      this.$store.commit("SET_HOME_PRODUCT_ID", id);
      this.$router.push({
        path: "/exhibitorHome/product",
        query: {
          status: 0,
        },
      });
    },
  },
};
</script>>
<style lang="scss" scoped>
.exhibitorHome {
  .service {
    width: 100%;
    height: 392px;
    background-color: #ffffff;
    margin-bottom: 20px;

    .service_ul {
      width: 790px;
      margin: 0 auto;
      list-style: square;
      li {
        height: 59px;
        line-height: 59px;
        font-size: 14px;
        color: #333333;
        border-bottom: 1px solid #dfe1e1;
        cursor: pointer;
        .leftDiv {
          float: left;
        }
        .rightDiv {
          float: right;
          color: #bbbbbb;
        }
      }
    }
  }
  .product {
    width: 100%;
    height: 749px;
    background-color: #ffffff;
    .pContent {
      padding: 0 20px;
      height: 619px;
      overflow: hidden;
      .c1 {
        width: 100%;
        // height: 140px;
        div {
          width: 195px;
          height: 140px;
          background-color: #f2f2f2;
          margin: 0 20px 20px 0;
          float: left;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        div:nth-child(4),
        div:nth-child(8),
        div:nth-child(12),
        div:nth-child(16) {
          margin-right: 0;
        }
      }
    }
  }
  .service,
  .product {
    .header {
      width: 100%;
      height: 30px;
      line-height: 35px;
      margin-bottom: 24px;
      .service_h {
        width: 100px;
        height: 100%;
        float: left;
        font-size: 16px;
        color: #143372;
        border-top: 2px solid #143372;
        border-right: 1px solid #bbbbbb;
        text-align: center;
      }
      .more {
        width: 62px;
        height: 100%;
        float: right;
        color: #2878ff;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>